// Consentement "mesure d'audience" (Google Analytics, Firebase Analytics).
// Source unique : la cle localStorage posee par components/CookieConsent.vue.
// En natif la banniere n'est pas montee et aucune mesure d'audience ne part.

import { isWeb } from './platform';

export const ANALYTICS_CONSENT_KEY = 'cookie_consent';
/** Evenement DOM emis a l'acceptation, ecoute par index.html (gtag) et lib/firebase.js */
export const ANALYTICS_CONSENT_EVENT = 'clocook:analytics-consent';

/** True quand l'utilisateur a accepte la mesure d'audience via la banniere cookies */
export function hasAnalyticsConsent() {
    if (!isWeb) return false;
    try {
        return localStorage.getItem(ANALYTICS_CONSENT_KEY) === 'accepted';
    } catch {
        return false;
    }
}

/**
 * A appeler juste apres l'acceptation : charge gtag.js (fonction exposee par
 * index.html) et previent les modules qui attendent le consentement.
 */
export function notifyAnalyticsConsent() {
    if (!hasAnalyticsConsent() || typeof window === 'undefined') return;
    try {
        if (typeof window.__clocookLoadGtag === 'function') window.__clocookLoadGtag();
        window.dispatchEvent(new CustomEvent(ANALYTICS_CONSENT_EVENT));
    } catch (e) {
        console.warn('[consent] notification impossible', e?.message || e);
    }
}
